// MinIO (dev) — change to your HTTPS host later
export const MEDIA_HOST   = "https://mrxyz.ngrok.app/";
export const MEDIA_BUCKET = "media"; // you said images are under /media/...
// your folder layout under the bucket:
export const GAME_PREFIX  = "memory-board";
